import { makeRandom, isArray } from './helper'

function getIOSHandler() {
  if (typeof window === 'undefined') return null
  const handler = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callNativeForH5
  return handler && typeof handler.postMessage === 'function' ? handler : null
}

function getAndroidBridge(type = 'callNativeForH5') {
  return typeof window !== 'undefined' ? window[type] : null
}

export function hasNativeBridge(code, type) {
  const android = getAndroidBridge(type)
  return !!(getIOSHandler() || (android && (!code || typeof android[code] === 'function')))
}

const callNativeByIOS = (code, name) => {
  const handler = getIOSHandler()
  if (!handler) return false
  handler.postMessage({
    code,
    name
  })
  return true
}

const notifyNativeByIOS = (code, data) => {
  const handler = getIOSHandler()
  if (!handler) return
  handler.postMessage({
    code,
    data
  })
}

const callNativeByAndroid = (code, data, type = 'callNativeForH5') => {
  const bridge = getAndroidBridge(type)
  if (bridge && typeof bridge[code] === 'function') {
    bridge[code](JSON.stringify(data))
  }
}


function callNative(code, data = {}, type) {
  // 普通浏览器或未注入对应方法的 WebView 不调用原生桥接。
  if (!hasNativeBridge(code, type)) return Promise.resolve()
  data = dataHelper(data)
  return new Promise(function (resolve, reject) {

    if (!Object.prototype.hasOwnProperty.call(data, 'success')) {
      data.success = makeCallback(null, resolve)
    }

    if (!Object.prototype.hasOwnProperty.call(data, 'fail')) {
      data.fail = makeCallback(null, null, reject)
    }


    if (getIOSHandler()) {
      const iosData = `${makeCallback(function () {
        return JSON.stringify(data)
      })}()`
      console.log(iosData, 'iosData');
      setTimeout(() => {
        try {
          // 延迟期间 WebView 可能已经移除了桥接。
          if (!callNativeByIOS(code, iosData)) resolve()
        } catch (error) {
          reject(error)
        }
      }, 500)
    } else {
      console.log({ code, data }, 'code');

      callNativeByAndroid(code, data, type)
    }

  })

}

function dataHelper(data, callback) {
  for (let key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const item = data[key]
      if (typeof item === 'object' && !isArray(item)) {
        data[key] = dataHelper(item, callback)
      } else if (typeof item === 'function') {
        data[key] = `${makeCallback(item, null)}${callback ? '()' : ''}`
      }
    }
  }
  return data
}

function makeCallback(fn, resolve, reject) {
  const random = makeRandom()
  const callbackName = `callback_${random}`
  window[callbackName] = (function (fn, callbackName) {
    return function (res) {
      // delete window[callbackName]
      console.log(resolve)
      if (resolve) {
        resolve(res)
      } else if (reject) {
        reject(res)
      } else {
        return fn(res)
      }
    }
  })(fn, callbackName)
  return callbackName
}

export default {
  call(...args) {
    console.info('callNative', args)
    return callNative(...args)
  },
  notify(code, data = {}, type) {
    if (!hasNativeBridge(code, type)) return
    data = dataHelper(data)
    if (getIOSHandler()) {
      notifyNativeByIOS(code, data)
    } else {
      callNativeByAndroid(code, data, type)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/callNative.js